import { memo, useState, useContext, useEffect } from "react"
import styles from "./index.module.scss"
import Radio from "../../../../atoms/Radio"
import intl from "react-intl-universal"
import { ControlsContext } from "../../../../../contexts/Controls"

export const OptionsResultsControlComponent = ({
  index,
  oResults,
  bdisabled,
  setIsChanged,
}) => {
  const { setDataConfigAnalyte, dataConfigAnalyte } = useContext(ControlsContext)
  const [bChecked, setBChecked] = useState(true)
  const [dataResults, setDataResults] = useState(oResults)
  // const [optsHistory, setOptsHistory] = useState([])

  const [cntrlanlt_cdescription] = useState(oResults.resultopt_cdescription)

  useEffect(() => {
    const itsNewAnalyte = dataConfigAnalyte?.eqpanlt_result_options?.every(item => !item?.cntrlanltrops_ecompliance);
    if (itsNewAnalyte) {
      if (dataConfigAnalyte.eqpanlt_result_options.length !== 0) {
        const eqpanlt_result_options = dataConfigAnalyte.eqpanlt_result_options
          .map((item) => ({
            resultopt_cdescription: item.cntrlanlt_cdescription,
            cntrlanltrops_resultopt_nid: item.cntrlanltrops_resultopt_nid,
            cntrlanltrops_ecompliance: "C",
          }))
          
        setDataConfigAnalyte({ ...dataConfigAnalyte, eqpanlt_result_options })
  
        return
      }
    } else {
      dataConfigAnalyte?.eqpanlt?.anlt_result_options?.map((item, index) => {
        const newResultOption = dataConfigAnalyte?.eqpanlt_result_options.find(i => i.cntrlanltrops_resultopt_nid === item.resultopt_nid)
        if (!newResultOption) {
          dataConfigAnalyte.eqpanlt_result_options.push({
            cntrlanltrops_resultopt_nid: item.resultopt_nid,
            cntrlanltrops_ecompliance: "C",
            resultopt_cdescription: item.resultopt_cdescription
          })
        }
      })
    }
    if (
      !dataConfigAnalyte?.eqpanlt_result_options[index]?.cntrlanltrops_ecompliance
      && !itsNewAnalyte
    ) {
      setBChecked(true)
    } else if (
      dataConfigAnalyte?.eqpanlt_result_options[index]?.cntrlanltrops_ecompliance ===
        "C" ||
      dataConfigAnalyte?.eqpanlt?.anlt_result_options[index]
        ?.cntrlanltrops_ecompliance === "C"
    ) {
      setBChecked(true)
    } else if (
      dataConfigAnalyte?.eqpanlt_result_options[index]?.cntrlanltrops_ecompliance ===
        "N" ||
      dataConfigAnalyte?.eqpanlt?.anlt_result_options[index]
        ?.cntrlanltrops_ecompliance === "N"
    ) {
      setBChecked(false)
    }
  }, [dataResults])

  useEffect(() => {
    if (dataConfigAnalyte.eqpanlt_result_options.length !== 0) {
      if (Object.keys(dataConfigAnalyte?.eqpanlt_result_options[0])?.length === 3) {
        setDataResults(dataConfigAnalyte.eqpanlt_result_options[index])
      }
    }
  }, [])

  const fnHndleClick = (ecompliance) => {
    if (bdisabled) return

    const checkedHashMap = {
      "C": true,
      "N": false,
    }
    setBChecked(checkedHashMap[ecompliance])

    const obj = {
      // ...dataResults,
      cntrlanlt_cdescription,
      cntrlanltrops_resultopt_nid:
        dataResults.resultopt_nid || dataResults.cntrlanltrops_resultopt_nid,
      cntrlanltrops_ecompliance: ecompliance,
    }

    setIsChanged(true)

    if (dataConfigAnalyte.eqpanlt_result_options.length !== 0) {
      const eqpanlt_result_options = dataConfigAnalyte.eqpanlt_result_options
        .map((item, index) => ({
          resultopt_cdescription: item.cntrlanlt_cdescription,
          cntrlanltrops_resultopt_nid: item.cntrlanltrops_resultopt_nid,
          cntrlanltrops_ecompliance: item.cntrlanltrops_ecompliance,
        }))
        .map((item) => {
          if (item.cntrlanltrops_resultopt_nid === obj.cntrlanltrops_resultopt_nid) {
            return {
              ...obj,
            }
          } else {
            return item
          }
        })
        
      setDataConfigAnalyte({ ...dataConfigAnalyte, eqpanlt_result_options })

      return
    }

    const eqpanlt_result_options = dataConfigAnalyte.eqpanlt.anlt_result_options
      .map((item, index) => ({
        resultopt_cdescription:
          dataConfigAnalyte.eqpanlt.anlt_result_options[index].resultopt_cdescription,
        cntrlanltrops_resultopt_nid:
          dataConfigAnalyte.eqpanlt.anlt_result_options[index].resultopt_nid,
        cntrlanltrops_ecompliance: item.cntrlanltrops_ecompliance,
      }))
      .map((item) => {
        if (item.cntrlanltrops_resultopt_nid === obj.cntrlanltrops_resultopt_nid) {
          return {
            ...obj,
          }
        } else {
          return {
            ...item,
            cntrlanltrops_ecompliance: "C",
          }
        }
      })

    setDataConfigAnalyte({ ...dataConfigAnalyte, eqpanlt_result_options })
  }

  return (
    <div
      key={dataResults?.resultopt_nid}
      className={`${styles.resultOptionContainer} ${bdisabled ? styles.opacity : ""}`}
    >
      <span>{oResults.resultopt_cdescription}</span>

      <div className={styles.flex}>
        <div
          onClick={() => fnHndleClick("C")}
          className={(bChecked) ? styles.selected : ""}
        >
          <Radio
            label={intl.get("ciq.according")}
            checked={bChecked}
            disabled={bdisabled}
          />
        </div>
        <div
          onClick={() => fnHndleClick("N")}
          className={!bChecked ? styles.selected : ""}
        >
          <Radio
            label={intl.get("ciq.not_according")}
            checked={!bChecked}
            disabled={bdisabled}
          />
        </div>
      </div>
    </div>
  )
}

export const OptionsResultsControl = memo(OptionsResultsControlComponent)
